import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pushNotification } from 'src/modules/Notification';
import { useIntl } from 'react-intl';

import FontIcon from 'src/components/FontIcon';

import theme from 'src/styles/components/SubmitOrderButton.module.scss';

export default function useErrorNotification(
    {
        message,
        cancelFunc
    },
    invert = true,
    icon = 'icon-info'
) {
    const intl = useIntl();
    const dispatch = useDispatch();

    useEffect(() => {
        if (message) {
            dispatch(pushNotification({
                invert,
                message: (
                    <div className={theme.notification}>
                        <div className={theme.notificationIcon}>
                            <FontIcon value={icon} />
                        </div>
                        {intl.formatMessage({ id: `App.${message}` })}
                    </div>
                ),
                isDismissButtonEnabled: false,
                onDismiss: cancelFunc
            }));
        }
    }, [message]);

    return [];
}
